<template>
  <div>
    <div class="yk-wrap-fixed wlx-site-manager-wrapper">
      <header class="u-school-manager-head site-manager-head-con">
        <span class="fl sp-test-detail-title">{{meetTitle}}</span>
          <el-form :inline="true">
            <el-form-item>
              <div>
                <el-input v-model="DisplayName" placeholder="请输入姓名" clearable></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <div>
                <el-select v-model="planId" clearable placeholder="请选择培训轮次">
                  <el-option
                    v-for="item in planList"
                    :key="item.Id"
                    :label="item.planTime"
                    :value="item.Id">
                  </el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              <el-button type="primary" @click="ImportDialogVisible=true">Excel导入</el-button>
              <!-- <a class="export-button-a" style="color:#fff" :href="exportExcel">导入</a> -->
              <a class="export-button-a" style="color:#fff" :href="exportExcel">导出Excel</a>
              <a class="export-button-a" style="color:#fff" :href="exportPhoto">导出头像</a>
              <!-- <a class="export-button-a" style="color:#fff" :href="exportExcelStu">按报名人员导出</a> -->
              <el-button type="primary" icon="wl-icon-ai207" @click="goBack"></el-button>
            </el-form-item>
          </el-form>
      </header>
      <div class="wlx-table-content">
        <el-table
          :data="list"
          tooltip-effect="dark"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="name" show-overflow-tooltip label="姓名" width="200"></el-table-column>
          <el-table-column prop="phone" show-overflow-tooltip label="手机号" width="200"></el-table-column>
          <el-table-column prop="schoolTitle" label="学校" show-overflow-tooltip></el-table-column>
          <el-table-column prop="email" label="邮编" show-overflow-tooltip></el-table-column>
          <el-table-column prop="invoice" label="发票抬头" show-overflow-tooltip></el-table-column>
          <el-table-column prop="taxNumber" label="纳税人识别号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="planTime" label="培训轮次" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.planTime">{{scope.row.planTime}}</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="personCount" label="报名人数" show-overflow-tooltip width="160"></el-table-column> -->
          <el-table-column prop="dateCreated" label="创建时间" width="160"></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                size="mini"
                class="el-icon-view"
                @click="goView(scope.row.id)"
                type="primary"
                title="详情"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          class="wl-pagination-text"
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0"
        ></el-pagination>
      </div>
    </div>
       <!--导入-->
    <el-dialog :before-close="cancel"
               title="Excel导入"
               :visible.sync="ImportDialogVisible"
               width="50%"
               top="3%"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false">
      <p class="excelparaph">注意事项：</p>
      <ul class="attention_excel">
        <li>写表格时请注意查看填写须知</li>
      </ul>
      <el-form ref="form"
               label-width="80px"
               size="mini"
               @submit.prevent="importFile">
        <el-upload class="upload-demo"
                   ref="upload"
                   :data="{activityId}"
                   :action="uploadUrl"
                   :file-list="fileList"
                   :auto-upload="false"
                   :on-success="onSuccess"
                   accept="xls"
                   :limit="1"
                   style="display: inline-block; margin: 0 44px;">
          <el-button slot="trigger"
                     size="small"
                     type="primary">选取文件</el-button>
          <div slot="tip"
               class="el-upload__tip"></div>
        </el-upload>

        <a style="color: #049cdb; text-decoration: underline;"
           href="/public/doc/导入报名人员模板.xls">下载模板</a>

        <el-table :data="errorList"
                  v-show="errorList.length > 0"
                  style="width: 100%">
          <el-table-column prop="row"
                           label="行号"
                           width="180"></el-table-column>
          <el-table-column prop="error"
                           label="错误"
                           style="width:80%"></el-table-column>
        </el-table>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary"
                   @click="importFile()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      ids: [],
      DisplayName: "",
      companyName:"",
      meetTitle: "",
      exportExcel:"",
      exportPhoto:'',
      exportExcelStu:"",
      // 导入
      ImportDialogVisible:false,
      errorList:[],
      fileList:[],
      uploadUrl:"/api/XOrg/ImportPeiXun/uploadExcel",
      // 培训轮次
      planList:[],
      planId:''
    };
  },
  props: {
    activityId: {
      type: String,
      default: ""
    }
  },
  created() {
    this.school = this.$store.state.auth.userName;
    this.getPeiXunEnrollList();
    this.getPeiXunPlan();
    this.exportExcel = "/api/XOrg/SpecialActivity/exportPeiXunExcel?activityId="+ this.activityId;
    this.exportPhoto = "/api/XOrg/SpecialActivity/exportPeiXunPhoto?activityId="+ this.activityId;
  },
  methods: {
    // 获取培训轮次
    getPeiXunPlan(){
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/getPeiXunPlan", {
          activityId: this.activityId
        })
        .then(rst => {
          if (rst.code == 1) {
            this.planList = rst.list;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    getPeiXunEnrollList(page) {
      var that = this;
      this.$http
        .post("/api/XOrg/SpecialActivity/getPeiXunEnrollList", {
          planId:this.planId,
          name: this.DisplayName,
          activityId: this.activityId,
          page: page,
          pageSize: this.pageSize
        })
        .then(rst => {
          if (rst.code == 1) {
            this.list = rst.list;
            this.meetTitle = rst.meetTitle;
            this.total = rst.pagination.totalCount;
            this.pageSize = rst.pagination.pageSize;
            this.pageIndex = rst.pagination.pageIndex;
          } else {
            this.$message.warning(rst.msg);
          }
        });
    },
    onPageChangeHandler(page) {
      this.getPeiXunEnrollList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPeiXunEnrollList(1);
    },
    handleSelectionChange(val) {
      this.ids = [];
      val.forEach(element => {
        this.ids.push(element.Id);
      });
    },
    search() {
      this.getPeiXunEnrollList(1);
    },
    goView(id) {
      this.$router.push({
        name: "trainSignDetail",
        params: {
          signUpId: id
        }
      });
    },
    goBack() {
      this.$router.push({
        name: "tarinActivity"
      });
    },
    // 导入
    importFile() {
      this.$refs.upload.submit();
    },
    onSuccess(res) {
      if (res.code < 0) {
        if (res.code === -5) {
          this.errorList = res.list;
        } else {
          this.$message.warning(res.msg);
        }
      } else {
        this.$message.success("导入成功");
        this.ImportDialogVisible = false;
        this.fileList = [];
        this.getPeiXunEnrollList();
      }
    },
    cancel() {
      this.ImportDialogVisible = false;
      this.dialogVisible = false;
      this.fileList = [];
    },
  }
};
</script>

<style lang="scss">
.yk-wrap-fixed {
  .sp-test-detail-title {
    padding: 0 15px;
    font-size: 16px;
    color: #2d82ff;
    // border-bottom: 2px solid #2d82ff;
    line-height: 59px;
    min-width: 30px;
    text-align: center;
  }
  .wlx-table-content {
    margin-top: 84px;
  }
  .el-input--suffix .el-input__inner {
    padding-right: 30px;
    height: 34px;
  }
  .wl-pagination-text {
    text-align: center;
    margin-top: 30px;
  }
  .site-manager-head-con {
    text-align: right;
  }
  .el-form-item__content {
    .el-button {
      padding: 8px 15px;
    }
  }
  .export-button-a{
    color: #fff;
    background: #409EFF;
    padding: 8px 15px;
    border-radius: 4px;
    margin: 0 10px;
  }
}
</style>
